'use strict';

(function () {

    angular.module('zp').controller('footerController', footerController);

    /**@ngInject */
    function footerController(notify) {

        var vm = this;

        vm.emailForm = {};

        vm.sendEmail = sendEmail;

        ///////////////////////////////

        function sendEmail() {
            if (!vm.emailForm.$valid) {
                return;
            }
            notify({ message: 'Poruka uspesno poslata', classes: ['info'], position: 'right' });
        }
    }
})(window.angular);